import { control } from '../main.js'

export default control
